import React, { FC, HTMLAttributes } from 'react'
import { Link as RRDLink, LinkProps } from 'react-router-dom'
import styled, { css } from 'styled-components'

const linkStyles = css`
  color: ${({ theme }) => theme.global.colors.genoa};
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.global.colors.elemyGreen};
  }
  :active {
    color: ${({ theme }) => theme.global.colors.genoa};
  }
`

const StyledRRDLink = styled(RRDLink)`
  ${linkStyles}
`

const StyledLink = styled.a`
  ${linkStyles}
`

export const Link: FC<LinkProps> = ({ children, ...rest }) => <StyledRRDLink {...rest}>{children}</StyledRRDLink>

export const HTMLLink: FC<HTMLAttributes<HTMLAnchorElement>> = ({ children, ...rest }) => (
  <StyledLink {...rest}>{children}</StyledLink>
)
